/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} DisplayInputs */



/**
* | output |
* | --- |
* | "Display" |
*
* @param {DisplayInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const display = /** @type {((inputs?: DisplayInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<DisplayInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Affichage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Anzeige")
	if (locale === "it") return /** @type {LocalizedString} */ ("Display")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отображать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("展示")
	if (locale === "ja") return /** @type {LocalizedString} */ ("画面")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रदर्शन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar")
	return /** @type {LocalizedString} */ ("Display")
});